/**
 * @Author: Nenad Brcic
 * @Date: 30.05.16
 * @Email: neno@neno.ch
 */

import React from 'react';
import Icon from '../../shared/Icon';
import CSSModules from 'react-css-modules';
import styles from './IconBar.scss';
import settings from '../../../../config/settings';


const IconBar = (props) => {
    const iconClassName = settings.search.fields.className ? settings.search.fields.className : '';
    let iconHighlights;
    let iconForKids;

    if (!!props.object.ObjHighlight) {
        if(props.object.ObjHighlight.indexOf('Highlights') > -1) {
            iconHighlights = <i><Icon icon="Vitra_Highlights.svg" /></i>
        }
        if(props.object.ObjHighlight.indexOf('Für Kinder') > -1) {
            iconForKids = <i><Icon icon="Vitra_Kids.svg" /></i>
        }
    }

    return (
        <div styleName="icon-bar">
            {
                !!props.object.ObjObjectNumberTxt ? (
                    <span styleName="number">
                        <i styleName="hash-icon" className={ iconClassName }>
                            <Icon icon={settings.search.fields.icon} />
                        </i>
                        <span styleName="number-text">{ props.object.ObjObjectNumberTxt }</span>
                    </span>
                ) : null
            }
            {iconForKids}
            {iconHighlights}
        </div>
    )
};

export default CSSModules(IconBar, styles);


// WEBPACK FOOTER //
// ./app/components/Object/IconBar/index.jsx